import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {sendPasswordSharingWarningEmail} from 'src/openapi/admin/apis/UsersEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const usePasswordSharingWarningEmail = ({userId, onFail, onSuccess}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        sendPasswordSharingWarningEmail({userId}),
    ), [userId, apiDispatch]);

    return useCommonEventHook({eventAction, onFail, onSuccess});
};
